/// <reference path="../../typings/tsd.d.ts" /> 
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ContentPageService = /** @class */ (function (_super) {
            __extends(ContentPageService, _super);
            function ContentPageService($http) {
                return _super.call(this, $http) || this;
            }
            ContentPageService.prototype.getContentPagesForConfiguration = function () {
                var params = {};
                this.handlerUrl = "api/ContentManagement/ContentPage/GetContentPagesForConfiguration";
                return this.useGetHandler(params).then(function (result) {
                    return result;
                });
            };
            ContentPageService.prototype.getContentPagesForExecution = function () {
                var params = {};
                this.handlerUrl = "api/ContentManagement/ContentPage/GetContentPagesForExection";
                return this.useGetHandler(params).then(function (result) {
                    return result;
                });
            };
            ContentPageService.prototype.getContentPageForExecution = function (id) {
                var params = {};
                this.handlerUrl = "api/ContentManagement/ContentPage/GetContentPageForExecution?id=" + id;
                return this.useGetHandler(params).then(function (result) {
                    return result;
                });
            };
            ContentPageService.prototype.addContentPage = function (contentPage) {
                var params = contentPage;
                this.handlerUrl = "api/ContentManagement/ContentPage/CreateContentPage";
                return this.usePostHandler(params);
            };
            ContentPageService.prototype.updateContentPage = function (contentPage) {
                var params = contentPage;
                this.handlerUrl = "api/ContentManagement/ContentPage/UpdateContentPage";
                return this.usePostHandler(params);
            };
            ContentPageService.prototype.deleteContentPage = function (contentPage) {
                var params = contentPage;
                this.handlerUrl = "api/ContentManagement/ContentPage/DeleteContentPage";
                return this.usePostHandler(params);
            };
            return ContentPageService;
        }(services.HttpHandlerService));
        services.ContentPageService = ContentPageService;
        //    public getContentPagesTitles(): ng.IPromise<Wars.Domain.Model.ContentPage[]> {
        //        var namesQuery= this.breezeModule.EntityQuery
        //            .from("ContentPages")
        //            .select("title, id")
        //            .orderBy("title");
        //        return<any>this.executeQuery(namesQuery);
        //    }
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ContentPageService', ['$http']);
